import styled from 'styled-components';
import { Modal, ModalBody } from 'ui/modal';
import { BasicSelect } from 'ui/selects';
import { pxToRem } from 'utils/convert';

// TODO: Once locales are re-introduced, uncomment dialog min-height
export const StyledModal = styled(Modal)`
  /* dialog {
    min-height: ${pxToRem(405)};
  } */
`;

/** overflow-y: unset allows select dropdown to extend past modal boundaries */
export const StyledModalBody = styled(ModalBody)`
  overflow-y: unset;
`;

/** Setting option-wrapper max-height to 150px allows user to see up to 3 locales at a time */
export const StyledSelect = styled(BasicSelect)`
  display: block;

  [data-test='basic-select-option-wrapper-flex-message-locale-select'] {
    max-height: ${pxToRem(150)};
  }
`;
